// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { useTypedParams } from "react-router-typesafe-routes/dom";

import { GoLink, usePageTitle } from "~@jii/common-ui";
import { State } from "~@jii/paths";
import { useUsMaTranslations } from "~@jii/translation";

import {
  BackRow,
  Header,
  IconSlot,
  Intro,
  Title,
  TitleRow,
} from "./GuideHeader.styles";

type GuideHeaderProps = {
  title: string;
  iconSrc: string;
  intro: string;
};

export const GuideHeader = ({ title, iconSrc, intro }: GuideHeaderProps) => {
  const { t } = useUsMaTranslations();
  const routeParams = useTypedParams(State.Resident);

  usePageTitle(title);

  return (
    <Header>
      <BackRow>
        <GoLink
          back
          to={State.Resident.UsMaReentry.Overview.buildPath(routeParams)}
        >
          {t(($) => $.reentry.guide.back)}
        </GoLink>
      </BackRow>

      <TitleRow>
        <IconSlot>
          <img src={iconSrc} alt="" />
        </IconSlot>
        <Title>{title}</Title>
      </TitleRow>
      <Intro>{intro}</Intro>
    </Header>
  );
};
